import { ManagementDTO } from "../domain/models/dto/ManagementDTO";
import { IManagement } from "../domain/models/Management";
import { ManagementModel } from "../models/ManagementModel";
import { FileMapper } from "./FileMapper";
import { ManagementTranslationMapper } from "./ManagementTranslationMapper";
import { SimpleMapper } from "./SimpleMapper";

export class ManagementMapper extends SimpleMapper<IManagement, ManagementDTO> {
    protected toDTOFields: string[] = [
        "id",
        "files",
        "translations",
        "isActive",
    ];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "availableLangs",
        "creatorId",
        "createdAt",
        "updatedAt",
    ];
    protected entityConstructor = ManagementModel;
    private fileMapper = new FileMapper();
    private managementTranslationMapper = new ManagementTranslationMapper();

    toDTO(model: IManagement): ManagementDTO {
        if (!model) {
            return null;
        }

        const baseDto = super.toDTO(model);

        baseDto.translations =
            model.translations?.map((t) =>
                this.managementTranslationMapper.toDTO(t)
            ) ?? [];

        baseDto.files =
            model.files?.map((file) => this.fileMapper.toDTO(file)) ?? [];

        return baseDto;
    }

    fromDTO(dto: ManagementDTO): IManagement {
        if (!dto) {
            return null;
        }
        const baseModel = super.fromDTO(dto);

        baseModel.translations =
            dto.translations?.map((t) =>
                this.managementTranslationMapper.fromDTO(t)
            ) ?? [];

        baseModel.files =
            dto.files?.map((file) => this.fileMapper.fromDTO(file)) ?? [];
        return baseModel;
    }
}
